export enum UserGender {
    Male = 'male',
    Female = 'female'
}

export enum OnlineStatus {
    Online = 'online',
    Offline = 'offline',
}

export enum UserCategory {
    Test = 'test',
    Prod = 'prod',
}

export enum UserStatus {
    Blocked = 'blocked',
    Deleted = 'deleted',
    DeletedStartedByGdpr = 'deletedStartedByGdpr',
    DeletedByGdpr = 'deletedByGdpr',
    Active = 'active',
    Banned = 'banned',
    Deactivated = 'deactivated'
}

export enum PayoutMethod {
    Usdt = 'usdt',
    Paxum = 'paxum',
    Bitcoin = 'bitcoin',
    Cosmo = 'cosmo',
    Sepa = 'sepa',
}

export enum PayoutDetailsStatus {
    Pending = 'pending',
    Valid = 'valid',
    Invalid = 'invalid'
}

export enum IdentityStatus {
    New = 'new',
    Pending = 'pending',
    Verified = 'verified',
    Rejected = 'rejected',
}

export enum VerificationType {
    AgeEstimation = 'age_estimation',
    IdentityDocument = 'identity_document',
    IdentityDocumentPassive = 'identity_document_passive',
    DigitalId = 'digital_id',
}

export enum UserAgeVerificationStatus {
    Pending = 'pending',
    Success = 'success',
}

export enum AgeVerificationStatus {
    New = 'new',
    Success = 'success',
    Fail = 'fail',
    Error = 'error',
    Deleted = 'deleted',
}

export enum VerificationProvider {
    Yoti = 'yoti',
    Facetec = 'facetec',
    Admin = 'admin',
}

export enum EmailConfirmType {
    Email = 'email',
    Recovery = 'recovery',
    FavoritesUnsubscribe = 'favoritesUnsubscribe',
    WelcomeUnsubscribe = 'welcomeUnsubscribe',
    MessagesUnsubscribe = 'messageUnsubscribe'
}

export enum NoticeType {
    Warn = 'warn',
    Block = 'block',
    Ban = 'ban'
}

export enum FavoriteType {
    User = 'user'
}

export enum AuthMethod {
    Email = 'email',
    Google = 'google',
    GoogleOneTap = 'googleOneTap',
}

export const BASE_OAUTH_METHODS = [AuthMethod.Google] as const;
export type BaseOAuthMethod = (typeof BASE_OAUTH_METHODS)[number];

export const OAUTH_METHODS = [...BASE_OAUTH_METHODS, AuthMethod.GoogleOneTap] as const;
export type OAuthMethod = (typeof OAUTH_METHODS)[number];

export enum AvailabilityType {
    All = 'all',
    AllExcept = 'allExcept',
    Only = 'only',
}

export enum BlockedType {
    User = 'user'
}
